import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Ported from sge_infantil_web (routes/api/notification.js in sge_infantil_core).
// POST /api/notification publishes one WhatsApp message per contact via SNS.
// The delivered text is built server-side from param1/param2/param3/agenda1-4/notes
// (per "type") — not from the "message" field, which the backend accepts but
// ignores. Callers (see NotifyModal.jsx) must fill in the right param* fields
// for the chosen type; "message" is still sent along for parity/debugging.
export async function sendNotification(payload) {
  const sucursal = getSucursalInfo();
  return API.post(`${baseURL}api/notification`, {
    sucursalId: sucursal?.id,
    ...payload,
  });
}

// Histórico de notificações enviadas para a sucursal (tabela SGE_SMS).
// { from, to }: datas "YYYY-MM-DD" opcionais para filtrar no backend.
export async function getNotificationHistory(sucursalId, { from, to } = {}) {
  const id = sucursalId || getSucursalInfo()?.id;
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  return API.get(`${baseURL}api/notification/sucursal/${id}`, { params });
}
